module.exports = __webpack_public_path__ + "static/media/zoomOut.0e4f59cf.svg";